import { useMapErinnerungszeitenToFristdatum } from '@/domain/mitarbeiter/shared/hooks/useMapErinnerungszeitenToFristdatum/useMapErinnerungszeitenToFristdatum';
import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxItem,
  ComboboxList,
  ComboboxTrigger,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ErinnerungsZeitenMultiSelect({
  values,
  handleChange,
  fristdatum,
  title,
  id,
}: {
  values: string[];
  handleChange: (value: string[]) => void;
  fristdatum?: string;
  title: string;
  id?: string;
}) {
  const { t } = useTranslation();
  const options = useMapErinnerungszeitenToFristdatum(fristdatum);

  return (
    <Combobox
      multiple
      options={options}
      value={values}
      onValueChange={handleChange}>
      <ComboboxTrigger
        aria-labelledby={id}
        placeholder={t('combobox.placeholder')}
      />
      <ComboboxContent title={title}>
        <ComboboxList>
          {options.map((o) => (
            <ComboboxItem key={o.value} option={o} />
          ))}
          <ComboboxEmpty />
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
